import { GetTenantsList } from './../commands/get-tenants-list.command';
import {HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AnyAdapter} from '@drl/core/api/adapters/any-adapter.service';
import {ApiService} from '@drl/core/api/api.service';
import {ConfigKeys} from '@drl/core/enums/config-keys.enum';
import {GetTenantCommand, GetTenantProfileCommand} from '@drl/core/store/commands';
import { AuthTokenSkipHeader } from '@drl/core/interceptors/auth.interceptor';
import {WorkingTimingsConfigsAdapter} from '@drl/shared/adapters';
import {
  GetTenantConfigsCommand,
  UpdateTenantConfigCommand,
  GetSATenantConfigsCommand,
  UpdateDbSeededDataCommand,
} from '@drl/shared/commands';
import {
  SATenantConfig,
  TenantConfig,
  TenantDetails,
  WorkingTimings,
  WorkingTimingsConfig,
} from '@drl/shared/models';
import {Observable} from 'rxjs';

import {AlertsConfigAdapter} from '../adapters/alerts-config-adapter.service';
import {TenantProfileAdapter} from '../adapters/tenant-profile-adapter.service';
import {AlertConfigProps, AlertConfigsData} from '../models/alert-config.model';

@Injectable()
export class ConfigurationsFacadeService {
  constructor(
    private readonly apiService: ApiService,
    private readonly anyAdapter: AnyAdapter,
    private readonly alertConfigAdapter: AlertsConfigAdapter,
    private readonly tenProfileAdapter: TenantProfileAdapter,
    private readonly workingTimingAdapter: WorkingTimingsConfigsAdapter,
  ) {}

  getTenantProfile(): Observable<TenantDetails> {
    const command: GetTenantProfileCommand<TenantDetails> =
      new GetTenantProfileCommand(this.apiService, this.tenProfileAdapter);

    return command.execute();
  }

  getTenantDetailsByTenantKey(tenantKey){
    const command: GetTenantCommand<TenantDetails> = new GetTenantCommand(this.apiService, this.tenProfileAdapter);
    const queryStr = JSON.stringify({
      where: {
        key: tenantKey
      },
      fields:{
        pubKey:true,
        subKey:true,
      }
    });


    command.parameters = {
      headers: new HttpHeaders().set(AuthTokenSkipHeader, ''),
      query: new HttpParams().set('filter', queryStr),

    };
    return command.execute();
  }

  getTenantConfigs(configKey): Observable<TenantConfig> {
    const command: GetTenantConfigsCommand<TenantConfig> = new GetTenantConfigsCommand(
      this.apiService,
      this.anyAdapter,
    );

    command.parameters = {
      query: new HttpParams().set('config_key', configKey),
    };
    return command.execute();
  }

  getSATenantConfigs(tenantName): Observable<SATenantConfig> {
    const command: GetSATenantConfigsCommand<SATenantConfig> = new GetSATenantConfigsCommand(
      this.apiService,
      this.anyAdapter,
    );

    command.parameters = {
      headers: new HttpHeaders().set(AuthTokenSkipHeader, ''),
      query: new HttpParams().set('name', tenantName),
    };
    return command.execute();
  }

  updateDbSeededValues(locale) {
    const command: UpdateDbSeededDataCommand<TenantDetails> = new UpdateDbSeededDataCommand(
      this.apiService,
      this.anyAdapter,
    );

    command.parameters = {
      headers: new HttpHeaders().set('locale', locale),
    };
    return command.execute();
  }

  getWorkingTimingsConfigs(): Observable<WorkingTimingsConfig> {
    const command: GetTenantConfigsCommand<WorkingTimingsConfig> = new GetTenantConfigsCommand(
      this.apiService,
      this.workingTimingAdapter,
    );

    command.parameters = {
      query: new HttpParams().set('config_key', ConfigKeys.WorkingTimings),
    };
    return command.execute();
  }

  getAlertConfigs(): Observable<AlertConfigsData> {
    const command: GetTenantConfigsCommand<AlertConfigsData> = new GetTenantConfigsCommand(
      this.apiService,
      this.alertConfigAdapter,
    );

    command.parameters = {
      query: new HttpParams().set('config_key', ConfigKeys.AlertConfigs),
    };
    return command.execute();
  }

  updateTenantConfig(configKey: string, configVal: object) {
    const command: UpdateTenantConfigCommand<TenantConfig> = new UpdateTenantConfigCommand(
      this.apiService,
      this.anyAdapter,
    );

    const queryData = {
      configKey: undefined,
    };
    if (configKey) {
      queryData.configKey = configKey;
    }
    command.parameters = {
      data: {configValue: configVal},
      query: new HttpParams().set('where', JSON.stringify(queryData)),
    };

    return command.execute();
  }

  updateWorkingTimingsConfig(configVal: WorkingTimings) {
    const command: UpdateTenantConfigCommand<WorkingTimingsConfig> = new UpdateTenantConfigCommand(
      this.apiService,
      this.workingTimingAdapter,
    );

    const queryData = {
      configKey: undefined,
    };
    queryData.configKey = ConfigKeys.WorkingTimings;

    command.parameters = {
      data: {configValue: configVal},
      query: new HttpParams().set('where', JSON.stringify(queryData)),
    };

    return command.execute();
  }

  updateAlertConfigs(configVal: AlertConfigProps) {
    const command: UpdateTenantConfigCommand<AlertConfigsData> = new UpdateTenantConfigCommand(
      this.apiService,
      this.anyAdapter,
    );

    const queryData = {
      configKey: undefined,
    };
    queryData.configKey = ConfigKeys.AlertConfigs;

    command.parameters = {
      data: {configValue: configVal},
      query: new HttpParams().set('where', JSON.stringify(queryData)),
    };

    return command.execute();
  }

  getTenantsList(): Observable<TenantDetails> {
    const command: GetTenantsList<TenantDetails> =
      new GetTenantsList(this.apiService, this.anyAdapter);
      command.parameters = {
        headers: new HttpHeaders().set(AuthTokenSkipHeader, ''),
      };
    return command.execute();
  }
}
